import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationModel } from 'src/app/models/notifications.model';

@Component({
  selector: 'app-banner-notification',
  templateUrl: './banner-notification.component.html',
  styleUrls: ['./banner-notification.component.scss'],
})
export class ModalBannerNotifComponent {
  @Input() isVisibleBanner = false;
  @Output() isVisibleBannerEvent = new EventEmitter<boolean>();
  destroy$ = new Subject<void>();
  notifications: NotificationModel[] = [];
  currentNotificationIndex = 0;
  get currentNotification() {
    return this.notifications[this.currentNotificationIndex];
  }

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.notificationService.getBanners().subscribe((data) => {
      const dismissedIds = this.getDismissedBannerIds();
      this.notifications = data.filter(
        (notif) => notif.is_recurring || !dismissedIds.includes(notif.id)
      );
    });
  }
  
  handleCancel(notif: NotificationModel): void {
    this.saveDismissedBanner(notif.id);
  
    this.currentNotificationIndex++;
  
    if (this.currentNotificationIndex >= this.notifications.length) {
      this.isVisibleBannerEvent.emit(false);
    }
  }  
  
  private getDismissedBannerIds(): number[] {
    const raw = localStorage.getItem('dismissedBanners');
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed.map(id => Number(id)) : [];
    } catch {
      return [];
    }
  }  
  
  private saveDismissedBanner(id: number): void {
    const dismissed = this.getDismissedBannerIds();
    if (!dismissed.includes(id)) {
      dismissed.push(id);
      localStorage.setItem('dismissedBanners', JSON.stringify(dismissed));
    }
  }  
  
}
